import "../App.css";
import hunanlogo from "../assets/images/uni/hunan.jpeg";
import nanchanglogo from "../assets/images/uni/Nanchang_Hangkong_University_logo.png";
import shihez from "../assets/images/uni/Shihezi_University_logo.png";
import yangtze from "../assets/images/uni/Yangtze_University_logo.png";
import parullogo from "../assets/images/uni/parul.png";
import { useState } from "react";
import { motion } from "framer-motion";
import { universities } from "../model/universities-model.jsx";


export const Unversities = () => {
  const [hoveredUniversity, setHoveredUniversity] = useState(null);

  // Map university names to their logos
  const universityLogos = {
    'HUNAN UNIVERSITY OF CHINESE MEDICINE': hunanlogo,
    'NANCHANG HANGKONG UNIVERSITY': nanchanglogo,
    'YANGTZE UNIVERSITY': yangtze,
    'SHIHEZI UNIVERSITY': shihez,
    'PARUL UNIVERSITY': parullogo,
  };

  return (
    <>
      <h1 className="section-headers">MOST POPULAR UNIVERSITIES</h1>
      <div className="universities" >
        {universities.slice(0, 4).map((university, index) => (
          <motion.div
            initial={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.5 + index * 0.1 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.1 }}
            key={index}
            className="university card"
            style={{ position: 'relative', overflow: 'hidden' }}
            onMouseEnter={() => setHoveredUniversity(university.name)}
            onMouseLeave={() => setHoveredUniversity(null)}
          >
            <span className="uni-title">{university.name}</span>
            <br />
            <img
              src={universityLogos[university.name]}
              alt={university.name}
              className="unilogo"
              style={{
                width: '100%',
                maxWidth: 210,
                height: 200,
                objectFit: 'cover',
                display: 'block',
                margin: '16px auto'
              }}
            />
            {hoveredUniversity === university.name && (
              <motion.div 
                className="university-details-overlay"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.3, ease: "easeOut" }}
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.8) 100%)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '12px',
                  padding: '20px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  color: 'white',
                  overflow: 'hidden',
                  zIndex: 10
                }}
              >
                <div style={{ 
                  flex: 1, 
                  overflowY: 'auto', 
                  paddingRight: '8px',
                  marginBottom: '16px'
                }}>
                  {/* Custom scrollbar styling */}
                  <style>
                    {`
                      .university-details-overlay div::-webkit-scrollbar {
                        width: 6px;
                      }
                      .university-details-overlay div::-webkit-scrollbar-track {
                        background: rgba(255, 255, 255, 0.1);
                        border-radius: 3px;
                      }
                      .university-details-overlay div::-webkit-scrollbar-thumb {
                        background: rgba(79, 70, 229, 0.6);
                        border-radius: 3px;
                      }
                      .university-details-overlay div::-webkit-scrollbar-thumb:hover {
                        background: rgba(79, 70, 229, 0.8);
                      }
                    `}
                  </style>
                  
                  {/* Location Section */}
                  <div style={{ marginBottom: '16px' }}>
                    <h4 style={{ 
                      fontWeight: 'bold', 
                      fontSize: '14px', 
                      color: '#4F46E5',
                      marginBottom: '8px',
                      textTransform: 'uppercase',
                      letterSpacing: '1px'
                    }}>
                      📍 Location
                    </h4>
                    <p style={{ 
                      fontFamily: 'sans-serif', 
                      fontSize: '13px',
                      lineHeight: '1.4',
                      color: '#E5E7EB',
                      margin: 0
                    }}>
                      {university.country}, {university.province}, {university.city}, {university.district}
                    </p>
                  </div>

                  {/* Programmes Section */}
                  <div style={{ marginBottom: '16px' }}>
                    <h4 style={{ 
                      fontWeight: 'bold', 
                      fontSize: '14px', 
                      color: '#4F46E5',
                      marginBottom: '8px',
                      textTransform: 'uppercase',
                      letterSpacing: '1px'
                    }}>
                      🎓 Programmes
                    </h4>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                      {university.programmes.map((programme, idx) => (
                        <span 
                          key={idx}
                          style={{
                            background: 'rgba(79, 70, 229, 0.2)',
                            color: '#C7D2FE',
                            padding: '4px 8px',
                            borderRadius: '12px',
                            fontSize: '11px',
                            fontFamily: 'sans-serif',
                            border: '1px solid rgba(79, 70, 229, 0.3)'
                          }}
                        >
                          {programme}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Courses Section */}
                  <div style={{ marginBottom: '16px' }}>
                    <h4 style={{ 
                      fontWeight: 'bold', 
                      fontSize: '14px', 
                      color: '#4F46E5',
                      marginBottom: '8px',
                      textTransform: 'uppercase',
                      letterSpacing: '1px'
                    }}>
                      📚 Available Courses
                    </h4>
                    <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                      {university.courses.phd && (
                        <div style={{
                          background: 'rgba(16, 185, 129, 0.2)',
                          border: '1px solid rgba(16, 185, 129, 0.3)',
                          borderRadius: '8px',
                          padding: '8px 12px',
                          textAlign: 'center',
                          minWidth: '60px'
                        }}>
                          <div style={{ fontSize: '12px', color: '#10B981', fontWeight: 'bold' }}>PhD</div>
                          <div style={{ fontSize: '16px', color: '#D1FAE5', fontWeight: 'bold' }}>
                            {university.courses.phd.length}
                          </div>
                        </div>
                      )}
                      {university.courses.masters && (
                        <div style={{
                          background: 'rgba(59, 130, 246, 0.2)',
                          border: '1px solid rgba(59, 130, 246, 0.3)',
                          borderRadius: '8px',
                          padding: '8px 12px',
                          textAlign: 'center',
                          minWidth: '60px'
                        }}>
                          <div style={{ fontSize: '12px', color: '#3B82F6', fontWeight: 'bold' }}>Master's</div>
                          <div style={{ fontSize: '16px', color: '#DBEAFE', fontWeight: 'bold' }}>
                            {university.courses.masters.length}
                          </div>
                        </div>
                      )}
                      {university.courses.degree && (
                        <div style={{
                          background: 'rgba(245, 158, 11, 0.2)',
                          border: '1px solid rgba(245, 158, 11, 0.3)',
                          borderRadius: '8px',
                          padding: '8px 12px',
                          textAlign: 'center',
                          minWidth: '60px'
                        }}>
                          <div style={{ fontSize: '12px', color: '#F59E0B', fontWeight: 'bold' }}>Bachelor's</div>
                          <div style={{ fontSize: '16px', color: '#FEF3C7', fontWeight: 'bold' }}>
                            {university.courses.degree.length}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Apply Button */}
                <button 
                  style={{
                    background: 'linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%)',
                    border: 'none',
                    borderRadius: '8px',
                    padding: '12px 20px',
                    color: 'white',
                    fontWeight: 'bold',
                    fontSize: '14px',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    boxShadow: '0 4px 15px rgba(79, 70, 229, 0.4)',
                    width: '100%'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 6px 20px rgba(79, 70, 229, 0.6)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 15px rgba(79, 70, 229, 0.4)';
                  }}
                >
                  <a
                    href="/aas/universities-list"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ 
                      textDecoration: 'none', 
                      color: 'inherit',
                      display: 'block'
                    }}
                  >
                    View Courses & Apply →
                  </a>
                </button>
              </motion.div>
            )}
          </motion.div>
        ))}
      </div>
    </>
  );
};
